var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowFolderClosedTransparent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "145px",
    viewBox: "0 0 114 145",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow_Folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Folder",
    fillRule: "nonzero",
    fill: "#1F2631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7401611,125.590282 L86.7255736,89.0865363 C87.0914755,88.7506063 87.0914755,88.2088464 86.7255736,87.8748582 L46.6018842,51.2507215 C46.3338398,51.0079975 45.929646,50.9322676 45.5786355,51.0643094 C45.227625,51.1963513 45,51.5089798 45,51.8565605 L45,125.108718 L45,125.14367 C45,125.615525 45.4190852,126 45.9381553,126",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowFolderClosedTransparent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_folder_closed_transparent.c91da75e860fa787791348a75ca0e772.svg";